import { toast } from 'sonner';

import { Icon } from './icon';
import { Button } from './shadcn/button';

export function CellWithCopy({ textToCopy, children }: { textToCopy: string; children: React.ReactNode }) {
  return (
    <div className="flex gap-2">
      {children}
      <Button
        size="sm"
        className="px-1"
        variant="ghost"
        onClick={(e) => {
          e.stopPropagation();
          navigator.clipboard.writeText(textToCopy);
          toast.success('Copied to clipboard');
        }}
      >
        <Icon className="lucide--copy text-sm" />
      </Button>
    </div>
  );
}
